import { SatisfactionRateQuestion } from './../../../../models/reporting/satisfaction-rate-question.model';
import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-satisfaction-rate-module',
  templateUrl: './satisfaction-rate-module.component.html',
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class SatisfactionRateModuleComponent implements OnInit {
@Input() satisfactions: Array<SatisfactionRateQuestion>;
 
constructor() {
  
}

ngOnInit() { }
}
